import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ['valueField']

  loadDataAttrToFieldValue(event) {
    const selectedOption = event.currentTarget.options[event.currentTarget.selectedIndex]
    const selectedRate = selectedOption?.dataset?.value || ''
    this.valueFieldTarget.value = selectedRate
  }

}
